<footer class="main-footer">
  <div class="container-dynamic d-flex justify-content-center">
    &copy; WIT 2023
  </div>
</footer>
